<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Addome" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Forma</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.forma }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.forma" :options="formaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Forma</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.formaDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.formaDescrizione" :disabled="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Cicatrice Ombelicale</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.cicatriceOmbelicale }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.cicatriceOmbelicale" :options="cicatriceOmbelicaleOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Cicatrice Ombelicale</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.cicatriceOmbelicaleDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.cicatriceOmbelicaleDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Cicatrice Chirurgica</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.cicatriceChirurgica }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.cicatriceChirurgica" :options="cicatriceChirurgicaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Cicatrice Chirurgica</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.cicatriceChirurgicaDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.cicatriceChirurgicaDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Reticolo Venoso</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.reticoloVenoso }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.reticoloVenoso" :options="reticoloVenosoOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Reticolo Venoso</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.reticoloVenosoDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.reticoloVenosoDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Trattabilità</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.trattabilita }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.trattabilita" :options="trattabilitaOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Trattabilità</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.trattabilitaDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.trattabilitaDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Massa Addominale</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.massaAddominale }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.massaAddominale" :options="massaAddominaleOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Massa Addominale</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.massaAddominaleDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.massaAddominaleDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Percussioni</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.percussione }}</span>
                            <b-form-select v-else v-model="jsonDataAddome.percussione" :options="percussioneOptions" :disabled="isReadOnly">
                                <template #first>
                                    <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Descrizione Percussione</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.percussioneDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.percussioneDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Elemento Semeiologico di Rilievo</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.elementoSemeiologicoRilievo }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.elementoSemeiologicoRilievo" :readonly="isReadOnly"> </b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Reazioni di Difesa:</label>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-row>
                                <b-col cols="auto" v-for="reazioni in reazioniDifesaOptions" :key="'reazioni-' + reazioni.id" class="sa-switch-select-element mr-3 mb-2">
                                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedReazioniDifesa" :value="reazioni.voce" @change="onSelectCheckBox" :key="listKey">
                                        <span style="font-weight: normal">{{ reazioni.voce }}</span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Descrizione Reazioni di Difesa</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.reazioneDifesaDescrizione }}</span>
                            <b-form-input v-else v-model="jsonDataAddome.reazioneDifesaDescrizione" :readonly="isReadOnly"> </b-form-input>
                        </b-col>

                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note</label>
                            <span v-if="isReadOnly">{{ jsonDataAddome.noteAddome }}</span>
                            <b-form-textarea v-else v-model="jsonDataAddome.noteAddome" :readonly="isReadOnly" max-rows="10" rows="7"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAddome: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    forma: "",
                    formaDescrizione: "",
                    cicatriceOmbelicale: "",
                    cicatriceOmbelicaleDescrizione: "",
                    cicatriceChirurgica: "",
                    cicatriceChirurgicaDescrizione: "",
                    reticoloVenoso: "",
                    reticoloVenosoDescrizione: "",
                    trattabilita: "",
                    trattabilitaDescrizione: "",
                    reazioneDifesaDescrizione: "",
                    massaAddominale: "",
                    massaAddominaleDescrizione: "",
                    percussione: "",
                    percussioneDescrizione: "",
                    elementoSemeiologicoRilievo: "",
                    noteAddome: "",
                    listaSchedaAddomeDettagli: [],
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.loadDizionarioData();
    },
    watch: {
        jsonDataAddome: {
            handler(jsonData) {
                this.$emit("update", jsonData);
                this.popolaArrayReazioniDifesa();
            },
            deep: true,
        },
    },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceSchedaEsameObiettivoGeneraleAddome: "/rsaschedaesameobiettivogeneraleaddome",
            pathResourceDizionario: "/rsadizionario",
            reazioniDifesaOptions: [],
            selectedReazioniDifesa: [],
            listKey: 0,
            formaOptions: [
                { text: "PIANO", value: "PIANO" },
                { text: "GLOBOSO", value: "GLOBOSO" },
                { text: "AVVALLATO", value: "AVVALLATO" },
                { text: "BRATACIANO", value: "BRATACIANO" },
            ],
            cicatriceOmbelicaleOptions: [
                { text: "NORMOINTROFLESSA", value: "NORMOINTROFLESSA" },
                { text: "PIANA", value: "PIANA" },
                { text: "ESTROFLESSA", value: "ESTROFLESSA" },
                { text: "ERNIATA", value: "ERNIATA" },
            ],
            cicatriceChirurgicaOptions: [
                { text: "ASSENTI", value: "ASSENTI" },
                { text: "PRESENTI", value: "PRESENTI" },
            ],
            reticoloVenosoOptions: [
                { text: "ASSENTE", value: "ASSENTE" },
                { text: "PRESENTE", value: "PRESENTE" },
            ],
            trattabilitaOptions: [
                { text: "TRATTABILE", value: "TRATTABILE" },
                { text: "SCARSAMENTE TRATTABILE", value: "SCARSAMENTE TRATTABILE" },
            ],
            massaAddominaleOptions: [
                { text: "ASSENTI", value: "ASSENTI" },
                { text: "PRESENTI", value: "PRESENTI" },
            ],
            percussioneOptions: [
                { text: "TIMPANISMO ENTEROCOLICO (TEC)", value: "TIMPANISMO ENTEROCOLICO C" },
                { text: "FISIOLOGICO SU TUTTO L'AMBITO", value: "FISIOLOGICO SU TUTTO L'AMBITO" },
                { text: "AUMENTATO", value: "AUMENTATO" },
                { text: "ALTERATO PER OTTUSITA'", value: "ALTERATO PER OTTUSITA'" },
            ],
        };
    },
    methods: {
        popolaArrayReazioniDifesa() {
            let me = this;
            // console.log("STO INIZIANDO A FARE IL POPOLAMENTO NEL METODO popolaArrayReazioniDifesa del [4° LIVELLO] con il seguente jsonDataAddome:", this.jsonDataAddome);
            me.selectedReazioniDifesa = [];
            if (me.jsonDataAddome.listaSchedaAddomeDettagli.length > 0) {
                // console.log("SONO ALL'INTERNO DELLA CONDIZIONE IF DEL METODO popolaArrayReazioniDifesa del [4° LIVELLO], entro se ho: ", me.jsonDataAddome.listaSchedaAddomeDettagli);
                // console.log("me.jsonDataAddome.listaSchedaAddomeDettagli.length: ", me.jsonDataAddome.listaSchedaAddomeDettagli.length);
                me.jsonDataAddome.listaSchedaAddomeDettagli.forEach((item) => {
                    if (item.tipo === "REAZIONI_DIFESA") {
                        me.selectedReazioniDifesa.push(item.voce);
                    }
                });
            }
            // console.log("FINE POPOLAMENTO [4° LIVELLO], listaSchedaAddomeDettagli DETTAGLIO: ", me.jsonDataAddome.listaSchedaAddomeDettagli);
        },
        onSelectCheckBox() {
            let me = this;
            let listaSchedaAddomeDettagli = [];

            me.selectedReazioniDifesa.forEach((voce) => {
                listaSchedaAddomeDettagli.push({
                    id: null,
                    idSchedaEsameObiettivoGeneraleAddome: me.jsonDataAddome.id,
                    tipo: "REAZIONI_DIFESA",
                    voce: voce,
                });
            });
            me.jsonDataAddome.listaSchedaAddomeDettagli = listaSchedaAddomeDettagli;

            // console.log(" {onSelectCheckBox} Lista REAZIONI_DIFESA:", me.selectedReazioniDifesa);
            // console.log(" {onSelectCheckBox} Lista Scheda REAZIONI_DIFESA", me.jsonDataAddome.listaSchedaAddomeDettagli);
        },

        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },
        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.reazioniDifesaOptions = response.data.data.list.filter((item) => item.tipo === "REAZIONI_DIFESA");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle reazioni di difesa", error);
        },
        onSalvaAddome() {
            let me = this;
            me.jsonDataAddome.idAccettazione = me.idAccettazione;
            // console.log("Salvataggio ADDOME con dati:", JSON.stringify(me.jsonDataAddome));
            if (!me.jsonDataAddome.idAccettazione) {
                // console.log("idAccettazione: ", me.jsonDataAddome.idAccettazione);
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }

            let listaSchedaAddomeDettagli = [];
            me.selectedReazioniDifesa.forEach((voce) => {
                listaSchedaAddomeDettagli.push({
                    id: null,
                    idSchedaEsameObiettivoGeneraleAddome: me.jsonDataAddome.id,
                    tipo: "REAZIONI_DIFESA",
                    voce: voce,
                });
            });
            me.jsonDataAddome.listaSchedaAddomeDettagli = listaSchedaAddomeDettagli;

            UtilityMixin.methods.saveResource(me.pathResourceSchedaEsameObiettivoGeneraleAddome, me.jsonDataAddome, me.saveSchedaEsameObiettivoGeneraleAddomeSuccessResponse, me.saveSchedaEsameObiettivoGeneraleAddomeErrorResponse);
        },
        saveSchedaEsameObiettivoGeneraleAddomeSuccessResponse() {
            //console.log("ADDOME salvato con successo:", response);
        },
        saveSchedaEsameObiettivoGeneraleAddomeErrorResponse() {
            console.error("Errore nel salvataggio ADDOME:");
        },
        /*  loadAddomeData() {
            let me = this;
            // console.log("ID accettazione nel loadAddomeData: " + me.idAccettazione);
            me.selectedReazioniDifesa = [];
            me.loadDizionarioData();
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaEsameObiettivoGeneraleAddome + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaEsameObiettivoGeneraleAddomeSuccess, me.resultResponseSchedaEsameObiettivoGeneraleAddomeError);
        },
        resultResponseSchedaEsameObiettivoGeneraleAddomeSuccess(response) {
            let me = this;
            me.jsonDataAddome = response.data.data;
            me.jsonDataAddome.listaSchedaAddomeDettagli.forEach((item) => {
                if (item.tipo === "REAZIONI_DIFESA") {
                    me.selectedReazioniDifesa.push(item.voce);
                }
            });

            //console.log("ID del record ADDOME:", me.jsonDataAddome.id);
        },
        resultResponseSchedaEsameObiettivoGeneraleAddomeError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                //console.log("NESSUN record trovato del ADDOME per questo id accettazione");
                me.resetForm();
            } else {
                console.error("Errore nel caricamento dati della sezione ADDOME:", error);
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAddome = {
                id: null,
                idAccettazione: me.idAccettazione,
                forma: null,
                formaDescrizione: null,
                cicatriceOmbelicale: null,
                cicatriceOmbelicaleDescrizione: null,
                cicatriceChirurgica: null,
                cicatriceChirurgicaDescrizione: null,
                reticoloVenoso: null,
                reticoloVenosoDescrizione: null,
                trattabilita: null,
                trattabilitaDescrizione: null,
                reazioneDifesaDescrizione: null,
                massaAddominale: null,
                massaAddominaleDescrizione: null,
                percussione: null,
                percussioneDescrizione: null,
                noteAddome: null,
                listaSchedaAddomeDettagli: [],
            };

            me.selectedReazioniDifesa = [];
        }, */
    },
};
</script>
